module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_9006.fc803233.png";